import http from '../api'

const apiPath = import.meta.env.VITE_API_PATH

export type EnumCase = {
  name: string
  value: number | string
}

export type EnumPayload = {
  key: string
  cases: EnumCase[]
}

type EnumSingleResponse = { data: EnumPayload }
type EnumListResponse = { data: EnumPayload[] }

async function getAllEnums() {
  return await http.get<EnumListResponse>(`${apiPath}enums`)
}

async function getEnumByKey(enumKey: string) {
  return await http.get<EnumSingleResponse>(`${apiPath}enums/${enumKey}`)
}

const enumsService = {
  getAllEnums,
  getEnumByKey,
}

export default enumsService
